import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=d9409234"
import script from "./teacher.vue?vue&type=script&lang=ts"
export * from "./teacher.vue?vue&type=script&lang=ts"
import style0 from "./teacher.vue?vue&type=style&index=0&id=d9409234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports